import type { DocumentShort, FolderFilesItem, Team } from "@/api";
import type { TeamModel } from "@/models/TeamModel";

export const findFirstDocument = (items?: FolderFilesItem[]): DocumentShort | undefined => {
  if (!items) {
    return undefined;
  }
  for (const item of items) {
    if (item.typename === "DocumentShort") {
      return item;
    }
    if (item.typename === "Folder") {
      const found = findFirstDocument(item.files);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};

export const getFirstDocumentOfTeam = (team?: Team | TeamModel) => {
  if (!team) {
    return undefined;
  }
  const firstRootFile = findFirstDocument(team.root?.files);
  if (firstRootFile) {
    return firstRootFile;
  }
  const firstDraftFile = findFirstDocument(team.drafts?.files);
  if (firstDraftFile) {
    return firstDraftFile;
  }
  const firstPublishedFile = findFirstDocument(team.published?.files);
  if (firstPublishedFile) {
    return firstPublishedFile;
  }
  return undefined;
};
